import 'bootstrap/dist/css/bootstrap.css';
global.jQuery = require('jquery');
require('bootstrap');

import '../sass/main.scss';

import 'owl.carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';

import '@fancyapps/fancybox';
import '@fancyapps/fancybox/dist/jquery.fancybox.min.css';

import 'calc-polyfill/calc.min';
import 'picturefill';

import 'jquery-mask-plugin';

//import 'select2';
//import 'select2/dist/css/select2.min.css';

var setCookie = function (name,value,days) {
	var expires = "";
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + (days*24*60*60*1000));
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

var getCookie =  function(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for(var i=0;i < ca.length;i++) {
		var c = ca[i];
		while (c.charAt(0)==' ') c = c.substring(1,c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
	}
	return null;
}

var eraseCookie =  function(name) {   
	document.cookie = name+'=; Max-Age=-99999999;';  
}

jQuery(document).ready(function($){

	if( getCookie('politicas') != 'aceito'){
		$('.cookies').addClass('active');

		$(".aceitarCookies").on('click tap touchstart', function() {
		   $('.cookies').removeClass('active');
		   setCookie('politicas', 'aceito', 365);
	   });
	} 

    $('.telefone').mask('(00) 0000-00009');

    //$('.js-example-basic-single').select2();
    $('a[href="#"]').click(function(e){
        e.preventDefault();
    });
 
    $('.hamburger-menu').click(function(){
        $(this).toggleClass('active');
        $('#headmobile').toggleClass('active');
    });

    $('#headmobile li.menu-item-has-children').click(function(){
        $(this).toggleClass('active');
    });

});